

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const formatNumberToString = (num, decimals) => {
    return num.toFixed(decimals).toString().replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
}

const formatNumberThatCanBeAString =  (number, decimals) => {
    decimals = decimals ? decimals : 2
    if (typeof number  === "string"){
        if (isNaN(number)){
            // Provavilmente è perché hanno scrtitto la virgola come decimale
            number = parseFloat(number.replace(',','.'))
        } else  {
            number = parseFloat(number)
        }
    }
    return formatNumberToString(number,decimals)
}
const GlobalComponents = {
    install(Vue) {
        //  OLD ONES
        Vue.filter('bytes',  (bytes) => {
            var thresh = 1024;
            if(Math.abs(bytes) < thresh) {
                return bytes + ' B';
            }
            var units = ['kB','MB','GB','TB','PB','EB','ZB','YB'];
            var u = -1;
            do {
                bytes /= thresh;
                ++u;
            } while(Math.abs(bytes) >= thresh && u < units.length - 1);
            return bytes.toFixed(1)+' '+units[u];
        })

        Vue.filter('currencyFilter', (number) => {
            return isNaN(number) ? 0 : formatNumberThatCanBeAString(number , 2)
        })
        Vue.filter('currencyStringFilter', (number) => {
            return formatNumberThatCanBeAString(number , 2)
        })

        Vue.filter('qtaFilter',formatNumberThatCanBeAString)


    }
};

export default GlobalComponents;
